import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateCartonPropertyGroup } from "@/api/carton-property-group-api";
import { type CartonPropertyGroup } from "@/schemas";

import { CARTON_PROPERTY_GROUPS_QUERY_KEY } from "./use-carton-property-group";

export const useUpdateCartonPropertyGroup = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ data }: { cartonPropertyGroupId: string; data: CartonPropertyGroup }) => {
			await updateCartonPropertyGroup(data);

			await queryClient.refetchQueries({ queryKey: [CARTON_PROPERTY_GROUPS_QUERY_KEY] });
		},
	});
};
